/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import MarkdownTable from '../components/_atoms/MarkdownTable';
export const meta = {
  author: 'Eirik Herness Berre'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  disableHeadline: true,
  mdx: true,
  hideActions: true,
  meta: meta,
  title: "Cookie policy",
  subTitle: "Cookie policy for using Curipod",
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.p, {
        children: "Last update: July 21st, 2022"
      }), "\n", _jsx(_components.p, {
        children: "This website uses cookies."
      }), "\n", _jsx(_components.p, {
        children: "We use cookies to analyse the website traffic. And to provide customer support."
      }), "\n", _jsxs(MarkdownTable, {
        children: [_jsx("thead", {
          children: _jsxs("tr", {
            children: [_jsx("th", {
              children: "Name"
            }), "\n", _jsx("th", {
              children: "Provider"
            }), "\n", _jsx("th", {
              children: "Purpose"
            }), "\n", _jsx("th", {
              children: "Expiry"
            })]
          })
        }), _jsxs("tbody", {
          children: [_jsxs("tr", {
            children: [_jsx("td", {
              children: "track"
            }), "\n", _jsx("td", {
              children: "Curipod"
            }), "\n", _jsx("td", {
              children: "Toggle if traffic data should be sent to google analytics\t"
            }), "\n", _jsx("td", {
              children: "1 year"
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: "intercom_session"
            }), "\n", _jsx("td", {
              children: "Intercom"
            }), "\n", _jsx("td", {
              children: "Used by Intercom to track make sure you can continue to reach us via the chat window"
            }), "\n", _jsx("td", {
              children: "1 week\t"
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: "intercom_id"
            }), "\n", _jsx("td", {
              children: "Intercom"
            }), "\n", _jsx("td", {
              children: "Used by Intercom to track make sure you can continue to reach us via the chat window"
            }), "\n", _jsx("td", {
              children: "1 year\t"
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: "i18nlang"
            }), "\n", _jsx("td", {
              children: "Language"
            }), "\n", _jsx("td", {
              children: "Used by Curipod to show you localised content"
            }), "\n", _jsx("td", {
              children: "1 year"
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: "nextauth-*"
            }), "\n", _jsx("td", {
              children: "Authentication"
            }), "\n", _jsx("td", {
              children: "Used by Curipod to provide you the Curipod service as an authenticated user"
            }), "\n", _jsx("td", {
              children: "15 minutes"
            })]
          })]
        })]
      })]
    });
  }
}
export default MDXContent;
